var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VCard',[_c('VCardTitle',[_vm._v("История статусов")]),_c('VCardText',[_c('VDataTable',{attrs:{"headers":_vm.headers,"items":_vm.items},scopedSlots:_vm._u([{key:"item.status",fn:function({ item: { status } }){return [_c('Chip',{attrs:{"status":status}})]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }